// extracted by mini-css-extract-plugin
export default {"root":"ListingConcludedFallback_root__Cudgm","title":"ListingConcludedFallback_title__76TNK h1","hint":"ListingConcludedFallback_hint__DgVuV"};